export default {"src":"/login-app/[GIT_HASH]/_next/static/media/data_object.f230391c.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};